/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TargetVsActualRow } from './TargetVsActualRow';
import {
    TargetVsActualRowFromJSON,
    TargetVsActualRowFromJSONTyped,
    TargetVsActualRowToJSON,
    TargetVsActualRowToJSONTyped,
} from './TargetVsActualRow';
import type { ExecutiveSummary } from './ExecutiveSummary';
import {
    ExecutiveSummaryFromJSON,
    ExecutiveSummaryFromJSONTyped,
    ExecutiveSummaryToJSON,
    ExecutiveSummaryToJSONTyped,
} from './ExecutiveSummary';
import type { ProgramHealthHeadline } from './ProgramHealthHeadline';
import {
    ProgramHealthHeadlineFromJSON,
    ProgramHealthHeadlineFromJSONTyped,
    ProgramHealthHeadlineToJSON,
    ProgramHealthHeadlineToJSONTyped,
} from './ProgramHealthHeadline';
import type { HeatmapRow } from './HeatmapRow';
import {
    HeatmapRowFromJSON,
    HeatmapRowFromJSONTyped,
    HeatmapRowToJSON,
    HeatmapRowToJSONTyped,
} from './HeatmapRow';
import type { RiskFlag } from './RiskFlag';
import {
    RiskFlagFromJSON,
    RiskFlagFromJSONTyped,
    RiskFlagToJSON,
    RiskFlagToJSONTyped,
} from './RiskFlag';

/**
 * 
 * @export
 * @interface ExecutiveDashboardView
 */
export interface ExecutiveDashboardView {
    /**
     * 
     * @type {Date}
     * @memberof ExecutiveDashboardView
     */
    computedAt?: Date;
    /**
     * 
     * @type {ProgramHealthHeadline}
     * @memberof ExecutiveDashboardView
     */
    programHealth?: ProgramHealthHeadline;
    /**
     * 
     * @type {Array<HeatmapRow>}
     * @memberof ExecutiveDashboardView
     */
    maturityHeatmap?: Array<HeatmapRow>;
    /**
     * 
     * @type {Array<TargetVsActualRow>}
     * @memberof ExecutiveDashboardView
     */
    targetVsActual?: Array<TargetVsActualRow>;
    /**
     * 
     * @type {Array<RiskFlag>}
     * @memberof ExecutiveDashboardView
     */
    riskFlags?: Array<RiskFlag>;
    /**
     * 
     * @type {ExecutiveSummary}
     * @memberof ExecutiveDashboardView
     */
    summary?: ExecutiveSummary;
}

/**
 * Check if a given object implements the ExecutiveDashboardView interface.
 */
export function instanceOfExecutiveDashboardView(value: object): value is ExecutiveDashboardView {
    return true;
}

export function ExecutiveDashboardViewFromJSON(json: any): ExecutiveDashboardView {
    return ExecutiveDashboardViewFromJSONTyped(json, false);
}

export function ExecutiveDashboardViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutiveDashboardView {
    if (json == null) {
        return json;
    }
    return {
        
        'computedAt': json['computedAt'] == null ? undefined : (new Date(json['computedAt'])),
        'programHealth': json['programHealth'] == null ? undefined : ProgramHealthHeadlineFromJSON(json['programHealth']),
        'maturityHeatmap': json['maturityHeatmap'] == null ? undefined : ((json['maturityHeatmap'] as Array<any>).map(HeatmapRowFromJSON)),
        'targetVsActual': json['targetVsActual'] == null ? undefined : ((json['targetVsActual'] as Array<any>).map(TargetVsActualRowFromJSON)),
        'riskFlags': json['riskFlags'] == null ? undefined : ((json['riskFlags'] as Array<any>).map(RiskFlagFromJSON)),
        'summary': json['summary'] == null ? undefined : ExecutiveSummaryFromJSON(json['summary']),
    };
}

export function ExecutiveDashboardViewToJSON(json: any): ExecutiveDashboardView {
    return ExecutiveDashboardViewToJSONTyped(json, false);
}

export function ExecutiveDashboardViewToJSONTyped(value?: ExecutiveDashboardView | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'computedAt': value['computedAt'] == null ? undefined : ((value['computedAt']).toISOString()),
        'programHealth': ProgramHealthHeadlineToJSON(value['programHealth']),
        'maturityHeatmap': value['maturityHeatmap'] == null ? undefined : ((value['maturityHeatmap'] as Array<any>).map(HeatmapRowToJSON)),
        'targetVsActual': value['targetVsActual'] == null ? undefined : ((value['targetVsActual'] as Array<any>).map(TargetVsActualRowToJSON)),
        'riskFlags': value['riskFlags'] == null ? undefined : ((value['riskFlags'] as Array<any>).map(RiskFlagToJSON)),
        'summary': ExecutiveSummaryToJSON(value['summary']),
    };
}

